import AddToCart from './AddToCart';

export default AddToCart;
export { useAddToCTCart, useAddToCart } from './hooks';
